import script from "./BibleNerdCorner.vue?vue&type=script&setup=true&lang=js"
export * from "./BibleNerdCorner.vue?vue&type=script&setup=true&lang=js"

import "./BibleNerdCorner.vue?vue&type=style&index=0&id=11218fda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11218fda"]])

export default __exports__